
import apiClient from '../helpers/apiClient';
import { authHeader } from '../helpers/authHeader';


export const permissionProfileService = {
    profileList,
    profileDetails,
    submitProfile,
    profileToggle,
    profileDetailsUnAssign,
    saveProfileAssign,
    profileAssignToUserList,
    profileDetailsAssignToUserDetail,
    saveProfileAssignToUser,
    profileAssignCustomerPermissions,
    menuAssignToUserList,
    saveMenuAssignToUser

};

//========= STOCK View =============== 
async function  profileList() {
    return apiClient.get(`/permission/profile-list`, authHeader());
}

async function  profileAssignToUserList() {
    return apiClient.get(`/permission/profile-assign-to-user-list`, authHeader());
}


async function  profileDetailsAssignToUserDetail(profileId) {
    return apiClient.get(`/permission/profile-assign-to-user-details/${profileId}`, authHeader());
}


async function  profileAssignCustomerPermissions(customerId) {
    return apiClient.get(`/permission/profile-assign-customer-permissions/${customerId}`, authHeader());
}


async function  profileDetails(profileId) {
    return apiClient.get(`/permission/profile-details/${profileId}`, authHeader());
}




async function  profileDetailsUnAssign(profileId) {
    return apiClient.get(`/permission/profile-details-unassign/${profileId}`, authHeader());
}

async function  saveProfileAssign(profileId, formData) {
    return apiClient.put(`/permission/save-profile-assign/${profileId}`, formData, authHeader());
}

async function  saveProfileAssignToUser(formData) {
    return apiClient.put(`/permission/save-profile-assign-to-user`, formData, authHeader());
}

async function  saveMenuAssignToUser(formData) {
    return apiClient.put(`/permission/save-menu-assign-to-user`, formData, authHeader());
}


async function  profileToggle(profileId) {
    return apiClient.put(`/permission/profile-toggle/${profileId}`, authHeader());
}


async function  submitProfile(formData) {
    return apiClient.post(`/permission/submit-profile`,formData, authHeader());
}





async function  menuAssignToUserList(userId) {
    return apiClient.get(`/permission/menu-assign-to-user-list/${userId}`, authHeader());
}









// async function  stockAdjustmentList() {
//     return apiClient.get(`/stock/stock-adjustment-list`, authHeader());
// }



// async function  stockAdjustmentListByDate(body) {
//     return apiClient.put(`/stock/stock-adjustment-by-date`, body, authHeader());
// }


// async function  stockAdjustmentSearch(searchText) {
//     return apiClient.get(`/stock/stock-adjustment-search?search=${searchText}`, authHeader());
// }

// async function  stockAdjustmentDetails(salesOrderId) {
//     return apiClient.get(`/stock/stock-adjustment-details/${salesOrderId}`, authHeader());
// }


// async function  submitStockAdjustment(formData) {
//     return apiClient.post(`/stock/submit-stock-adjustment`,formData, authHeader());
// }


// async function  stockAdjustmentAction(formData) {
//     return apiClient.put(`/stock/stock-adjustment-action`,formData, authHeader());
// }






















